import multipleFieldWidget from "./multipleFieldWidget.js";

/**
 * Form field widget for a multiple select list with two lists.
 */
function twoListMultipleSelectFieldWidget(spec, my) {
	spec ||= {};
	my ||= {};

	const that = multipleFieldWidget(spec, my);

	my.renderFieldOn = function (html) {
		// Selected items
		const selectTo = html.select(
			{ multiple: "multiple" },
			my.items
				.filter(my.isSelected)
				.map((item) =>
					html.option(
						{ value: my.serialize(item) },
						my.itemLabel(item),
					),
				),
		);

		// Available items
		const selectFrom = html.select(
			{ multiple: "multiple" },
			my.items
				.filter(my.isNotSelected)
				.map((item) =>
					html.option(
						{ value: my.serialize(item) },
						my.itemLabel(item),
					),
				),
		);

		const btnAdd = html
			.button({ class: "btn" }, "Add &laquo;")
			.click(() => {
				const itemsToAdd = selectFrom.asJQuery().val();
				let currentItems = my.items
					.filter(my.isSelected)
					.map((item) => my.serialize(item));

				currentItems = currentItems.concat(itemsToAdd);
				that.setValue(currentItems.map(my.deserialize));
			});

		const btnRemove = html
			.button({ class: "btn" }, "Remove &raquo;")
			.click(() => {
				const itemsToRemove = selectTo.asJQuery().val();
				let currentItems = my.items
					.filter(my.isSelected)
					.map((item) => my.serialize(item));

				currentItems = currentItems.subtract(itemsToRemove);
				that.setValue(currentItems.map(my.deserialize));
			});

		html.div(
			{ class: "row" },
			html.div({ class: "span4" }, selectTo),
			html.div({ class: "span4" }, btnAdd, html.br(), btnRemove),
			html.div({ class: "span4" }, selectFrom),
		);
	};

	return that;
}

export default twoListMultipleSelectFieldWidget;
